import { Navigate, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { hasAgencyPerm } from "@/lib/agencyPerms";

// Blocca l'accesso diretto via URL a una sezione Agency. Il backend resta
// autoritativo (403): questo evita solo una pagina vuota/errore.
export function AgencyPermGuard({ perm, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (hasAgencyPerm(user, perm)) return children;
  return (
    <div className="p-8" data-testid="agency-perm-denied">
      <div className="sp-card p-10 max-w-lg mx-auto text-center space-y-4">
        <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto">
          <ShieldAlert className="h-7 w-7 text-red-500" />
        </div>
        <h1 className="font-display text-2xl font-black">Accesso non consentito</h1>
        <p className="text-sm text-[color:var(--sp-text-secondary)]">
          Il tuo profilo non ha accesso a questa sezione dell'area Agency.
          Chiedi all'amministratore di abilitarti.
        </p>
      </div>
    </div>
  );
}

export default AgencyPermGuard;
